import { oc } from "@orpc/contract";
import { TimeFrameSchema } from "@domains/engagement/shared/timeFrame.ts";
import { FEEDBACK_METRIC_IDS } from "@domains/feedback/shared/feedbackTypes.ts";
import { ReportingScopeSchema } from "@packages/core/organization/scope.ts";
import { z } from "zod";
import { FEEDBACK_REPORT_SENTIMENTS, FEEDBACK_REPORT_TYPES } from "./feedbackReportFilters.ts";

export const FeedbackReportInputSchema = z.object({
    scope: ReportingScopeSchema.optional(),
    timeFrame: TimeFrameSchema.optional(),
    start: z.iso.date().optional(),
    end: z.iso.date().optional(),
    type: z.enum(FEEDBACK_REPORT_TYPES).optional(),
    sentiment: z.enum(FEEDBACK_REPORT_SENTIMENTS).optional(),
    metricId: z.enum(FEEDBACK_METRIC_IDS).optional(),
    labelId: z.string().optional()
});
export type FeedbackReportInput = z.infer<typeof FeedbackReportInputSchema>;

const TOPIC_SIGNALS = ["Risk", "Trending", "New"] as const;
export const TopicSignalSchema = z.enum(TOPIC_SIGNALS);
export type TopicSignal = z.infer<typeof TopicSignalSchema>;

const TopicSignalRowSchema = z.object({
    topicId: z.string(),
    topicName: z.string(),
    signal: TopicSignalSchema,
    feedbackVolume: z.number().int()
});
export type TopicSignalRow = z.infer<typeof TopicSignalRowSchema>;

const TopicSignalsSchema = z.object({
    topics: z.array(TopicSignalRowSchema)
});
export type TopicSignals = z.infer<typeof TopicSignalsSchema>;

export const feedbackReportContract = {
    getTopicSignals: oc.route({ method: "GET", path: "/topic-signals" }).errors({ UPSTREAM_FAILURE: {} }).input(FeedbackReportInputSchema).output(TopicSignalsSchema)
};
